/** Option lists mirrored from quote form product components */

export const LABEL_CORE_OPTIONS = ['1', '1.5', '2', '3', '4', '5', '6'].map((v) => ({
  value: v,
  label: v,
}));

export const LABEL_MATERIAL_OPTIONS = [
  'Card Stock (no adhesive)',
  'Clear BOPP',
  'Clear Poly E (Flexible Substrate)',
  'Cosmo (Speckled) Hologram Bopp',
  'Counterfeit Evident "Void"',
  'Direct Thermal Paper',
  'Double Sided (Clear or White BOPP)',
  'Double Sided (Paper + Clear Poly)',
  'Double Sided Silver BOPP',
  'Egg Shell',
  'Estate Wine Paper (Off-White)',
  'Estate Wine Paper (Textured)',
  'Estate Wine Paper (White)',
  'Heavy Clear Sachet Film',
  'Heavy Silver Sachet Film',
  'Hologram Paper',
  'Light Silver Sachet Film',
  'Neon Paper (only black print)',
  'Paper (Silver)',
  'Paper (White)',
  'Peel Back Hologram Bopp',
  'Peel Back Silver Bopp',
  'Peel Back White Bopp',
  'Shimmer (Standard) Hologram Bopp',
  'Shimmer Hologram Paper',
  'Silver BOPP',
  'Silver Poly E (Flexible Substrate)',
  'Stacked Wine Paper + Clear Poly',
  'Thermal Paper',
  'White BOPP',
  'White Bopp (114 micron)',
  'White Poly E (Flexible Substrate)',
].map((v) => ({ value: v, label: v }));

export const LABEL_FINISH_OPTIONS = [
  'Gloss Lamination',
  'Gloss Varnish',
  'Hologram Lamination',
  'Matte Lamination',
  'Matte Varnish',
  'No UV Finish',
  'No Finish',
  'F-35 Varnish',
].map((v) => ({ value: v, label: v }));

export const LABEL_APPLY_METHOD_OPTIONS = [
  { value: 'Automatic / Machine Application', label: 'Automatic / Machine Application' },
  { value: 'Manual / By Hand Application', label: 'Manual / By Hand Application' },
];

export const LABEL_PRINTING_FEATURES = [
  'Clear Stamping',
  'Cold Stamping 2 Colors',
  'Embossing',
  'Foil Stamping',
  'Hologram Stamping',
  'Hot Stamping 2 Colors',
  'Invisible Black Light Ink',
  'Metallics',
  'Perforation',
  'Print on Liner',
  'Raised Varnish',
  'Silver Ink',
  'Soft Touch Finish',
  'Spot UV',
  'Thermal Varnish',
  'UV Ink',
  'Variable Data',
  'Pre-Cut',
  'Scratch-off',
  'Easy removable adhesive',
  'Permanent adhesive',
  'Selective adhesive',
  'Refrigerated adhesive',
];

export const LABEL_ROLLING_DIRECTION_OPTIONS = ['1', '2', '3', '4'].map((v) => ({
  value: v,
  label: v,
}));

export const BAG_MATERIAL_OPTIONS = [
  'PET / VMPET / PE',
  'PET / PE',
  'MATTE OPP / VMPET / PE',
  'PET / AL / PE',
  'PET / LDPE',
  'ALOX',
  'KRAFT PAPER / PE',
  'KRAFT PAPER / VMPET / PE',
  'PE / PE (recyclable)',
  'KRAFT PAPER / PLA (compostable)',
  'MATTE OPP / PET / PE',
  'Other',
].map((v) => ({ value: v, label: v }));

export const BAG_PRINTING_FINISHES = [
  'Gloss Lamination',
  'Matte Lamination',
  'Gloss Varnish',
  'Matte Varnish',
  'Soft Touch',
  'Hologram Lamination',
].map((v) => ({ value: v, label: v }));

export const BOX_PRINTING_FINISHES = [
  'Gloss Lamination',
  'Hologram Lamination',
  'Matte Lamination',
  'Gloss Varnish',
  'Matte Varnish',
  'Soft Touch',
].map((v) => ({ value: v, label: v }));

export const SHRINK_MATERIAL_OPTIONS = [
  { value: 'PETG', label: 'PETG' },
  { value: 'PVC', label: 'PVC' },
];

export const SHRINK_FINISH_OPTIONS = ['Spot UV', 'Matte', 'Soft Touch', 'Gloss'];

export const SHRINK_APPLICATION_OPTIONS = [
  { value: 'Pre-Cut', label: 'Pre-Cut' },
  { value: 'On a Roll', label: 'On a Roll' },
];

export const BLISTER_MATERIAL_OPTIONS = [
  'PVC',
  'PET',
  'RPET',
  'Paperboard',
].map((v) => ({ value: v, label: v }));

export const BLISTER_HANGING_HOLE_OPTIONS = [
  { value: 'hang-hole', label: 'Hang Hole' },
  { value: 'sombrero-hole', label: 'Sombrero Hole' },
  { value: 'delta-hole', label: 'Delta Hole' },
];

export const CAP_ADDITIONAL_MATERIAL_OPTIONS = [
  { value: 'wood', label: 'Wood' },
  { value: 'metal', label: 'Metal' },
  { value: 'glass', label: 'Glass' },
];

export const SACHET_MATERIAL_OPTIONS = [
  'PET / AL / PE',
  'PET / VMPET / PE',
  'MATTE OPP / VMPET / PE',
  'KRAFT PAPER / PE',
].map((v) => ({ value: v, label: v }));

export const ENVELOPE_MATERIAL_OPTIONS = [
  'White Paper',
  'Kraft Paper',
  'Tyvek',
  'Bubble Mailer',
].map((v) => ({ value: v, label: v }));

export const MAILER_BAG_MATERIAL_OPTIONS = [
  'Poly Mailer',
  'Kraft Mailer',
  'Bubble Mailer',
  'Compostable Mailer',
].map((v) => ({ value: v, label: v }));

export const PRINTING_FEATURES_COMMON = [
  'Hologram Stamping',
  'Silver Ink',
  'Variable Data',
  'Hot Stamping',
  'Spot UV',
  'Invisible Black Light Ink',
  'Cold Stamping',
  'Raised Varnish',
  'Perforation',
  'Embossing',
];

/** Product types that use dedicated field steps (skip generic size/material text steps) */
export const DEDICATED_FIELD_PRODUCT_TYPES = [
  'Boxes',
  'Bags',
  'Labels',
  'Blisters',
  'Caps',
  'Bottles',
  'ShrinkSleeves',
  'Sachets',
  'Envelopes',
  'MailerBags',
];

export const OPTIONS_BY_STEP_ID = {
  labelCore: LABEL_CORE_OPTIONS,
  labelMaterial: LABEL_MATERIAL_OPTIONS,
  labelFinish: LABEL_FINISH_OPTIONS,
  labelApplyMethod: LABEL_APPLY_METHOD_OPTIONS,
  labelPrintingFeatures: LABEL_PRINTING_FEATURES,
  labelRollingDirection: LABEL_ROLLING_DIRECTION_OPTIONS,
  bagMaterial: BAG_MATERIAL_OPTIONS,
  bagPrintingFinishes: BAG_PRINTING_FINISHES,
  boxPrintingFinishes: BOX_PRINTING_FINISHES,
  shrinkMaterial: SHRINK_MATERIAL_OPTIONS,
  shrinkFinishes: SHRINK_FINISH_OPTIONS,
  shrinkApplication: SHRINK_APPLICATION_OPTIONS,
  blisterMaterial: BLISTER_MATERIAL_OPTIONS,
  blisterHangingHole: BLISTER_HANGING_HOLE_OPTIONS,
  capAdditionalMaterials: CAP_ADDITIONAL_MATERIAL_OPTIONS,
  sachetMaterial: SACHET_MATERIAL_OPTIONS,
  envelopeMaterial: ENVELOPE_MATERIAL_OPTIONS,
  mailerBagMaterial: MAILER_BAG_MATERIAL_OPTIONS,
  blisterPrintingFeatures: PRINTING_FEATURES_COMMON,
  shrinkPrintingFeatures: PRINTING_FEATURES_COMMON,
  boxPrintingFeatures: PRINTING_FEATURES_COMMON,
};

export function getOptionsForStep(step) {
  if (!step?.id) return null;
  const fromMap = OPTIONS_BY_STEP_ID[step.id];
  if (fromMap) {
    return Array.isArray(fromMap[0]) || typeof fromMap[0] === 'string'
      ? fromMap
      : fromMap.map((o) => (typeof o === 'string' ? o : o.value));
  }
  return null;
}

export function getSelectOptionsForStep(step) {
  const raw = OPTIONS_BY_STEP_ID[step?.id];
  if (!raw) return null;
  if (typeof raw[0] === 'string') {
    return raw.map((v) => ({ value: v, label: v }));
  }
  return raw;
}
